/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';
import Layout from './Layout';
import { HeroHome } from './HeroSections';
import Products from './Products';
import Technology from './Technology';
import Industries from './Industries';
import Clients from './Clients';
import { ServicesHome } from './Services';
import Testimonials from './Testimonials';
import About from './About';
import Team from './Team';
import Contact from './Contact';

interface PageProps { user: string | null; }

const HomePage = ({ user }: PageProps) => (
  <Layout user={user}>
    <HeroHome />
    <Products />
    <Technology />
    <Industries />
    <Clients />
    <ServicesHome />
    <Testimonials />
    <About />
    <Team />
    <Contact />
  </Layout>
);

export default HomePage;
